import { render } from "./ChooseProgram.vue?vue&type=template&id=35921fdd&scoped=true&ts=true"
import script from "./ChooseProgram.vue?vue&type=script&lang=ts"
export * from "./ChooseProgram.vue?vue&type=script&lang=ts"

import "./ChooseProgram.vue?vue&type=style&index=0&id=35921fdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35921fdd"]])

export default __exports__